import { createContext, useContext } from "react";

const SectionMenuContext = createContext(undefined);

function SectionMenuProvider({ children, value }) {
  return (
    <SectionMenuContext.Provider value={value}>
      {children}
    </SectionMenuContext.Provider>
  );
}

function useSectionMenuContext() {
  const context = useContext(SectionMenuContext);
  if (context === undefined) {
    throw new Error(
      "useSectionMenuContext must be used within a SectionMenuProvider"
    );
  }
  return context;
}

export { SectionMenuProvider, useSectionMenuContext };
